/**
 * Colored badge for document type
 * Per specification:
 * - Policy → Purple
 * - Procedure → Emerald
 * - Notice → Amber
 * - Agreement → Red
 * - Training Record → Yellow
 * - Regulatory Correspondence → Pink
 * - Template → Gray
 */
export function DocumentTypeBadge({ type }) {
  const typeConfig = {
    policy: {
      label: "Policy",
      bgColor: "#f3e8ff",
      textColor: "#581c87",
      borderColor: "#e9d5ff",
    },
    procedure: {
      label: "Procedure",
      bgColor: "#d1fae5",
      textColor: "#065f46",
      borderColor: "#a7f3d0",
    },
    notice: {
      label: "Notice",
      bgColor: "#fef3c7",
      textColor: "#92400e",
      borderColor: "#fcd34d",
    },
    agreement: {
      label: "Agreement",
      bgColor: "#fee2e2",
      textColor: "#991b1b",
      borderColor: "#fca5a5",
    },
    training_record: {
      label: "Training Record",
      bgColor: "#fef9c3",
      textColor: "#713f12",
      borderColor: "#fde047",
    },
    regulatory_correspondence: {
      label: "Regulatory Correspondence",
      bgColor: "#fce7f3",
      textColor: "#831843",
      borderColor: "#fbcfe8",
    },
    template: {
      label: "Template",
      bgColor: "#f3f4f6",
      textColor: "#374151",
      borderColor: "#d1d5db",
    },
  };

  // Normalize type to lowercase for lookup
  const normalizedType = (type || "").toLowerCase();
  const config = typeConfig[normalizedType] || {
    label: type,
    bgColor: "#f3f4f6",
    textColor: "#374151",
    borderColor: "#d1d5db",
  };

  return (
    <div
      style={{
        display: "inline-block",
        padding: "4px 10px",
        borderRadius: "6px",
        backgroundColor: config.bgColor,
        color: config.textColor,
        border: `1px solid ${config.borderColor}`,
        fontSize: "0.7rem",
        fontWeight: "500",
        whiteSpace: "nowrap",
      }}
    >
      {config.label}
    </div>
  );
}
